const fractionHoursListUtils = [

  {
    key: 1,
    name: "10 min",

  },
  {
    key: 2,
    name: "15 min",

  },
  {
    key: 3,
    name: "30 min",

  },
  {
    key: 4,
    name: "60 min",

  }

]

export { fractionHoursListUtils };


// WEBPACK FOOTER //
// src/utils/fraction-work-hours.js